import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-profile-image',
  templateUrl: './profile-image.component.html',
  styleUrls: ['./profile-image.component.scss']
})
export class ProfileImageComponent implements OnInit {

	imageChangedEvent: any = '';
	hotelID:any;
	customerID:any;
  	croppedImage: any = '';
  	imageLoader:boolean = true;
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialogRef: MatDialogRef<ProfileImageComponent>,
	) {
		this.imageChangedEvent = this.data.imageData;
	}

	ngOnInit() {
	}

	imageCropped(event) {
		this.croppedImage = event.base64;
	}
	imageLoaded() {
		
	}
	cropperReady() {
	  	this.imageLoader = false;
	}
	loadImageFailed() {
		
	}

	CloseCropImagePoupup(flag) {
		if(!flag) {
			this.croppedImage = '';
		}
		this.dialogRef.close(this.croppedImage);
	}

}
